export default __webpack_public_path__ + "static/media/newbg1.2130d0ff.png";